import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { Observable, finalize } from 'rxjs';
import { IGetTwitterPostsData } from '../../Models/ITwitterPost';
import { TwitterService } from '../../Services/twitter.service';
import {faExternalLink} from '@fortawesome/free-solid-svg-icons';
import { TwitterCommentDto, ITwitterComment } from '../../Models/ITwitterComment';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';
import { ITwitterPolitician } from '../../Models/ITwitterPolitician';

@Component({
  selector: 'app-twitter-post-details',
  templateUrl: './twitter-post-details.component.html',
  styleUrls: ['./twitter-post-details.component.scss']
})
export class TwitterPostDetailsComponent implements OnInit {
  @Input() postId?: string;
  postDetails: IGetTwitterPostsData | null = null;
  attackedPoliticianDetails: ITwitterPolitician | null = null;
  isLoading = false;
  error: string = '';

  //icons
  faExternalLink = faExternalLink;

  constructor(
    private drawerRef: NzDrawerRef<TwitterPostDetailsComponent>,
    private twitterService: TwitterService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.postId)
      this.loadPostDetails();
    else
      this.error = 'No post ID provided';
  }

  
  loadPostDetails(): void {
    this.isLoading = true;
    this.error = '';
    
    this.twitterService.getPostDetails(this.postId as string)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response: IGetTwitterPostsData) => {
          this.postDetails = response;
          if (this.postDetails.attackedPolitician !== null)

          
          // Check if postDetails has the required properties
          if (!this.postDetails || typeof this.postDetails !== 'object') {
            this.error = 'Invalid response format received';
          }
        },
        error: (error) => {
          this.error = 'Failed to load post details. Please try again.';
        }
      });
  }

  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }
  

  close(): void {
    this.drawerRef.close();
  }
}